import { translateAction } from '../mutations/agents-mutations';
import { agentUpdateActions, agentFieldMapping } from '../../const/agentsActions';

export const Actions = {
  async updateAgentsVersion({ commit }, agentName) {
    // const rand = Math.floor(Math.random() * 10);
    // if (rand < 5)
    //   return {
    //     Status: 'true',
    //     Message: 'Command sent',
    //   };
    // else
    //   return {s
    //     Status: 'faild',
    //     Message: 'Command sent',
    //   };

    commit('setAgentLock', { agentName, value: true });
    const result = {};
    setTimeout(() => {
      commit('setAgentLock', { agentName, value: false });
    }, 350);

    return result;
  },

  async updateAgent({ commit, state }, data) {
    if (!data.lockOverride) commit('setAgentLock', { agentName: data.agentName, value: true });
    const actionMenuAgentClone = JSON.parse(JSON.stringify(state.agentsList.find(agent => agent.Name === data.agentName)));
    const actionMenuAgentCloneNewVal = translateAction(data.action, data.value);
    actionMenuAgentClone[agentFieldMapping[data.action]] = actionMenuAgentCloneNewVal;
    commit('addAgentIntoActionMenu', actionMenuAgentClone);
    if (!agentUpdateActions.includes(data.action))
      return {
        agentName: data.agentName,
        status: 'Invalid Action',
        action: data.action,
      };
    const result = {};
    setTimeout(() => {
      if (!data.lockOverride) commit('setAgentLock', { agentName: data.agentName, value: false });
    }, 300);
    if (result && agentFieldMapping[data.action]) {
      if (result.Status === 'OK') {
        // TODO fix agents action menu reactivity
        // reactivty of context menu is currently not working since our source of true of the new updated agent data is coming from polling so this data provided to addAgentIntoActionMenu is refered to the old data.
        commit(
          'addAgentIntoActionMenu',
          state.agentsList.find(agent => agent.Name === data.agentName),
        );
        return {
          agentName: data.agentName,
          status: 'OK',
          action: data.action,
          agentObj: data.agentObj,
        };
      }
    }
    return {
      agentName: data.agentName,
      status: 'Failed',
      action: data.action,
      message: result.Message,
    };
  },

  async updateBuildcacheSettings({ commit }, data) {
    if (!data.lockOverride) commit('setAgentLock', { agentName: data.agentName, value: true });
    const result = {};
    setTimeout(() => {
      if (!data.lockOverride) commit('setAgentLock', { agentName: data.agentName, value: false });
    }, 300);
    if (result) {
      if (result.Status === 'OK') {
        return {
          agentName: data.agentName,
          status: 'OK',
          action: data.action,
          agentObj: data.agentObj,
        };
      }
    }
    return {
      agentName: data.agentName,
      status: 'Failed',
      action: data.action,
      message: result.Message,
    };
  },
  async registerAgent({ commit, state }, payload) {
    if (!(payload.data && payload.data.agentName && payload.data.initiatorLicense && payload.data.ciInitiatorLicense && payload.data.helperLicense)) return null;
    commit('setAgentLock', { agentName: payload.data.agentName, value: true });
    const actionMenuAgentClone = JSON.parse(JSON.stringify(state.agentsList.find(agent => agent.Name === payload.data.agentName)));
    if (actionMenuAgentClone.License) {
      actionMenuAgentClone.License.InitiatorType = payload.data.initiatorLicense;
      actionMenuAgentClone.License.CIInitiatorType = payload.data.ciInitiatorLicense;
      actionMenuAgentClone.License.HelperType = payload.data.helperLicense;
      actionMenuAgentClone.License.HelperCores = payload.data.helperLicense !== 'None' ? payload.data.requestedCores : 0;
    }
    commit('addAgentIntoActionMenu', actionMenuAgentClone);

    try {
      const result = {};
      if (result.Status !== 'OK') {
        commit(
          'addAgentIntoActionMenu',
          state.agentsList.find(agent => agent.Name === payload.data.agentName),
        );
        setTimeout(() => {
          commit('setAgentLock', { agentName: payload.data.agentName, value: false });
        }, 350);
      } else {
        setTimeout(() => {
          commit('setAgentLock', { agentName: payload.data.agentName, value: false });
        }, 350);
      }
      if (result && result.Message) {
        result.Message = result.Message.replace(/(\r\n|\n|\r)/gm, ' ');
      }

      return result;
    } catch (error) {
      commit('setAgentLock', { agentName: payload.data.agentName, value: false });

      return false;
    }
  },

  async releaseCloudAgent({ commit }, data) {
    commit('setAgentLock', { agentName: data.Name, value: true });
    const result = {};
    setTimeout(() => {
      commit('setAgentLock', { agentName: data.Name, value: false });
    }, 350);
    return result;
  },
};
